require('./contractInput.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const classNames = require('classnames');
// @ helpers
const { formatText } = require('core/i18n').i18n;
const { findElementbyId } = require('../../utilities/contractStateHelper');
const { getErrorMessage } = require('../../utilities/formValidationHelper');
// @ components
const { InputSafe } = require('commonsComponents/inputSafe');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

class ContractInput extends React.Component {
    constructor(props) {
        super(props);
        const { component, immCardDetails } = props;
        const { default_value, id: componentId, type, target: targetId } = component;
        const target = type === 'form' ? findElementbyId(immCardDetails, targetId) : immCardDetails;

        this.state = {
            value: findElementbyId(target, componentId) || default_value || ''
        };

        this.handleRegexOnKeyPressAndPaste = this.handleRegexOnKeyPressAndPaste.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputBlur = this.handleInputBlur.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        const { component, immCardDetails } = nextProps;
        const { default_value, id: componentId, type, target: targetId } = component;
        const target = type === 'form' ? findElementbyId(immCardDetails, targetId) : immCardDetails;

        this.setState({
            value: findElementbyId(target, componentId) || default_value || ''
        });
    }

    handleInputBlur(event) {
        this.props.onHandleBlur(event);
        this.setState({
            value: event.target.value
        });
    }

    handleInputChange(event) {
        const { onHandleValidateChange } = this.props;
        const { value } = event.target;

        if (!onHandleValidateChange || onHandleValidateChange(value)) {
            this.setState({
                value,
            });
        }
    }

    handleRegexOnKeyPressAndPaste(event) {
        const { component: { regex } } = this.props;
        const regexText = event.clipboardData
            ? event.clipboardData.getData('text/plain')
            : String.fromCharCode(event.charCode);

        if (regex && !regex.test(regexText) && !event.ctrlKey) {
            event.preventDefault();
        }
    }

    render() {
        const { value } = this.state;
        const { component, disabled: disabledByProps, immCardDetails } = this.props;
        const { id: componentId, placeholder, maxLength, label, disabled, tooltip } = component;
        const formattedPlaceholder = placeholder ? formatText(placeholder) : '';
        const inputLabel = label ? formatText(label) : null;
        const componentClasses = classNames('contract-input', component.customClass);
        const error = getErrorMessage(immCardDetails, component);
        let disabledField = false;
        let tooltipEl;

        if (disabled || disabledByProps) {
            const immComponentDetail = immCardDetails.find(
                immDetail => immDetail.get('id') === componentId
            );

            disabledField = immComponentDetail ? immComponentDetail.get('disabled') : disabled;
        }

        if (tooltip) {
            tooltipEl = (
                <span className="contract-input__custom-icon-wrapper">
                    <OKTooltip
                        content={tooltip}
                        offset={[15, 0]}
                        placement="right"
                    />
                </span>
            );
        }

        return (
            <div className={componentClasses} id={componentId}>
                {tooltipEl}
                <InputSafe
                    label={inputLabel}
                    name={componentId}
                    onKeyPress={this.handleRegexOnKeyPressAndPaste}
                    onPaste={this.handleRegexOnKeyPressAndPaste}
                    onBlur={this.handleInputBlur}
                    onChange={this.handleInputChange}
                    referenceName={componentId}
                    type={component.type_format}
                    value={value}
                    placeholder={formattedPlaceholder}
                    errorState={error.state}
                    errorMessage={error.message}
                    disabled={disabledField}
                    maxLength={maxLength}
                />
            </div>
        );
    }
}

ContractInput.propTypes = {
    component: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    immCardDetails: PropTypes.object.isRequired,
    onHandleBlur: PropTypes.func.isRequired,
    onHandleValidateChange: PropTypes.func,
};

ContractInput.defaultProps = {
    disabled: false,
}

module.exports = ContractInput;
